import React from 'react';

import EmailIcon from '@mui/icons-material/Email';
import LanguageIcon from '@mui/icons-material/Language';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import {
  Grid,
  Typography,
  Stack,
  Box,
  styled
} from '@mui/material';
import {
  ApiFile, LittleIconWithText, TitledChipGroup
} from 'modules';

import * as dataService from './dataService';



const CheckSizeTypography = styled(Typography)(({ theme }) => ({
  color: '#528898',
  fontSize: '14px'
}));

export interface ITopLevelDetailsSectionProps {}

export const TopLevelDetailsSection: React.FC<ITopLevelDetailsSectionProps> = props => {
  const { data } = dataService.useTopLevelDetailsSection();

  return (
    <Grid
      container
      spacing={6}>
      <Grid item>
        <ApiFile.FC
          fileKey={data.logoKey}
          widthPx={310}
          heightPx={310} />
      </Grid>

      <Grid
        item
        md={5}>
        <Stack
          spacing={2}
          alignItems="flex-start"
          direction="column">
          <Typography color='primary'>{data.companyName}</Typography>
          <Typography variant="h1">{data.fullName}</Typography>

          <Stack
            direction="row"
            alignItems="center"
            spacing={2}>
            <Typography>Check Size:</Typography>

            <CheckSizeTypography>
              {data.checkSizeMinDollars} - {data.checkSizeMaxDollars}
            </CheckSizeTypography>
          </Stack>

          <Box>
            <Grid
              container
              spacing={2}>
              <Grid
                item
                md={6}>
                <LittleIconWithText.FC
                  icon={LocationOnIcon}
                  iconText={data.address} />
              </Grid>

              <Grid
                item
                md={6}>
                <LittleIconWithText.FC
                  icon={LanguageIcon}
                  iconText={data.websiteUrl}
                  onClick={() => {
                    window.open(data.websiteUrl, '_blank');
                  }} />
              </Grid>

              <Grid
                item
                md={6}>
                <LittleIconWithText.FC
                  icon={EmailIcon}
                  iconText={data.email} />
              </Grid>

              <Grid
                item
                md={6}>
                <LittleIconWithText.FC
                  icon={PhoneIcon}
                  iconText={data.phoneNumber} />
              </Grid>

              <Grid
                item
                md={12}>
                <Typography>
                  {data.description}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Stack>
      </Grid>

      <Grid item xs={3}>
        <Stack spacing={5}>
          <TitledChipGroup.FC
            title="Company/Investment Stages"
            chipVariant="contained"
            alignLeft
            chipLabels={data.investmentStages} />

          <TitledChipGroup.FC
            title="Company/Investment Areas"
            chipVariant="outlined"
            alignLeft
            chipLabels={data.investmentAreas} />

          <TitledChipGroup.FC
            title="Investment Geography"
            chipVariant="text"
            alignLeft
            chipLabels={data.investmentGeographies} />
        </Stack>
      </Grid>
    </Grid>
  );
};
